import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import MainLayout from '../Layout/MainLayout.js';
import { blogPosts } from '../../data/blogPosts.js';
import { updateMetaTags } from '../../utils/metaTags.js';

const BlogPost = () => {
    const { slug } = useParams();
    const post = blogPosts.find(p => p.slug === slug);

    useEffect(() => {
        if (post) {
            updateMetaTags(
                `${post.title} - HåndværkerNet Blog`,
                post.excerpt,
                post.image || 'https://haandvaerkernet.dk/images/logo.png',
                'article'
            );
        }
    }, [post]);

    if (!post) return <div>Indlæg ikke fundet</div>;

    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <Link 
                    to="/blog"
                    className="inline-flex items-center text-amber-800 hover:text-amber-900 mb-8"
                >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    Tilbage til oversigten
                </Link>

                <article>
                    <header className="mb-8">
                        <div className="flex items-center text-sm text-gray-500 mb-2">
                            <span>{post.date}</span>
                            <span className="mx-2">•</span>
                            <span>{post.category}</span>
                        </div>
                        <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-4">
                            {post.title}
                        </h1>
                        <p className="text-xl text-gray-600">{post.excerpt}</p>
                    </header>
                    
                    <div 
                        className="prose prose-lg max-w-none"
                        dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                </article>
            </div>
        </MainLayout>
    );
};

export default BlogPost;